import { api } from "@api/api";
import { PlanMapOption } from "@modules/erpIntegrations/types";
import { PlanMapOptionFormValues } from "@modules/erpIntegrations/validations";

export async function createPlanMapOptionService(
  data: PlanMapOptionFormValues
): Promise<PlanMapOption> {
  const { data: option } = await api.post<PlanMapOption>(
    "/v1/integration_plan_map_option_admin/",
    data
  );

  return option;
}
